<template>
    <div>
        <template
            v-if="
                state.currentView == 'BANK_TRANSFER_DETAILS_VIEW' &&
                    state.processing != true &&
                    !clickedButton
            "
        >
            <div class="payment__form" v-if="!checkError">
                <!-- <template v-if="none"> -->
                <p class="container__col-md-12 container__col-sm-12 payment__instruction-2">
                    {{ $t("banktransfer.redirect.instruction")}}
                </p>
                <div v-if="state.currency == 'GHS'" class="payment__instruction--ghs">
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_10848_146310)">
                            <path d="M6.99967 11.6041C9.81863 11.6041 12.1038 9.31893 12.1038 6.49998C12.1038 3.68103 9.81863 1.39581 6.99967 1.39581C4.18072 1.39581 1.89551 3.68103 1.89551 6.49998C1.89551 9.31893 4.18072 11.6041 6.99967 11.6041Z" stroke="#4F4F4F" stroke-width="1.02083" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M7 3.44848V3.4375" stroke="#4F4F4F" stroke-width="1.02083" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M7 5.47919V9.56252" stroke="#4F4F4F" stroke-width="1.02083" stroke-linecap="round" stroke-linejoin="round"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_10848_146310">
                                <rect width="12.25" height="12.25" fill="white" transform="translate(0.875 0.375)"/>
                            </clipPath>
                        </defs>
                    </svg>

                    <p class="container__col-md-12 container__col-sm-12">Need help? <span class="more">See how to make a bank transfer</span></p>

                    <div class="payment__instruction--ghs--steps">
                        <h5>How to make a bank transfer</h5>
                        <ol>
                            <li>Launch your bank application</li>
                            <li>Input the Displayed account number as beneficiary</li>
                            <li>Select Instant pay as transfer mode</li>
                            <li>Authorize and Confirm Payment</li>
                            <li>Select "I have made the payment" on checkout</li>
                        </ol>
                    </div>
                </div>
                <!-- <div class="account-box">
                <div class="account-box__field">
                    <label> Account number </label>
                    <div class="account-copy">
                        <h4>{{ state.bankDetails.account }}</h4>
                        <copy-button :copyText="state.bankDetails.account" />
                    </div>
                </div>
                <div class="account-box__field">
                    <label> Bank Name </label>
                    <h4>
                        {{ state.bankDetails.bank }}
                    </h4>
                </div>
                <div class="account-box__field">
                    <label> Account name </label>
                    <h4>
                        {{ state.bankDetails.beneficiary }}
                    </h4>
                </div>
                <div class="account-box__field timer">
                    <figure ref="time"></figure>
                    <p role="timer" v-html="timer" class=""></p>
                </div> 
            </div> -->
                <div class="account-box">
                    <div v-if="state.currency == 'NGN'" class="amount-info-excess">
                        <svg width="15" height="15" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15"><path d="M6.987 0.582a6.987 6.987 0 1 0 0 13.976 6.987 6.987 0 0 0 0 -13.976m1.455 10.83q-0.538 0.211 -0.861 0.324t-0.747 0.111q-0.652 0 -1.016 -0.318a1.035 1.035 0 0 1 -0.36 -0.81q0 -0.189 0.026 -0.39 0.027 -0.197 0.087 -0.449l0.45 -1.59q0.06 -0.229 0.102 -0.432a1.95 1.95 0 0 0 0.039 -0.375q0 -0.304 -0.124 -0.423 -0.128 -0.12 -0.48 -0.12a1.2 1.2 0 0 0 -0.36 0.054 4.5 4.5 0 0 0 -0.312 0.105l0.12 -0.491q0.441 -0.18 0.844 -0.309 0.405 -0.129 0.764 -0.129 0.648 0 1.001 0.315 0.351 0.312 0.351 0.813 0 0.104 -0.024 0.364 -0.022 0.262 -0.09 0.48l-0.447 1.585a4.5 4.5 0 0 0 -0.099 0.435q-0.045 0.244 -0.044 0.37 0 0.315 0.141 0.43 0.143 0.115 0.491 0.115a2.1 2.1 0 0 0 0.669 -0.158l-0.12 0.488Zm-0.08 -6.435a1.05 1.05 0 0 1 -0.754 0.291 1.08 1.08 0 0 1 -0.758 -0.291 0.93 0.93 0 0 1 -0.315 -0.705q0 -0.414 0.315 -0.71a1.08 1.08 0 0 1 0.758 -0.294q0.441 0 0.754 0.294 0.315 0.295 0.315 0.708 0 0.414 -0.315 0.705Z" fill="#F5A623"/></svg>
                        <p>{{ $t("banktransfer.excess.amount.sub") }} </p>
                        <!-- <p v-if="state.currency == 'GHS'">{{ $t("banktransfer.excess.amount.ghs") }} </p> -->
                    </div>
                    <div class="account-box__field">
                        <label for="amount">AMOUNT</label>
                        <div class="account-copy">
                            <h4>
                                {{ state.currency }} {{ state.amount }}
                            </h4>                           
                            <copy-button :copyText="state.amount" />
                        </div>
                    </div>
                    <div class="account-box__field">
                        <label v-if="state.currency == 'EUR'"> IBAN </label>
                        <label v-else> {{ $t("banktransfer.account.number") }} </label>
                        <div v-if="state.currency == 'EUR'" class="account-copy">
                            <h4>{{ state.bankDetails.iban }}</h4>
                            <copy-button :copyText="state.bankDetails.iban" />
                        </div>
                        <div v-else class="account-copy">
                            <h4>{{ state.bankDetails.account }}</h4>
                            <copy-button :copyText="state.bankDetails.account" />
                        </div>
                    </div>
                    <div class="account-box__field">
                        <label v-if="state.currency == 'EUR'">{{ $t("banktransfer.account.swiftcode")}}</label>
                        <label v-if="state.currency == 'GBP'">{{ $t("banktransfer.account.sortcode")}}</label>
                        <label v-if="state.currency == 'NGN' || state.currency == 'GHS'"> {{ $t("banktransfer.account.bankname")}}</label>
                        <div class="account-copy" v-if="state.currency == 'EUR'">
                            <h4>
                                {{ state.bankDetails.bic_swift }}
                            </h4>
                        </div>
                        <div class="account-copy" v-if="state.currency == 'GBP'">
                            <h4>
                                {{ state.bankDetails.sort_code }}
                            </h4>
                        </div>
                        <h4 v-if="state.currency == 'NGN' || state.currency == 'GHS'">
                            {{ toTitle(state.bankDetails.bank) }}
                        </h4>
                    </div>
                    <div class="account-box__field">
                        <label> {{ $t("banktransfer.account.beneficiary") }} </label>
                        <h4>
                            {{ state.bankDetails.beneficiary }}
                        </h4>
                    </div>
                    <!-- <div class="account-box__field timer">
                    <figure ref="time"></figure>
                    <p role="timer" v-html="timer" class=""></p>
                </div> -->
                    <div class="dynamic-account-warning">
                        <svg width="15" height="15" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15"><path d="M6.987 0.582a6.987 6.987 0 1 0 0 13.976 6.987 6.987 0 0 0 0 -13.976m1.455 10.83q-0.538 0.211 -0.861 0.324t-0.747 0.111q-0.652 0 -1.016 -0.318a1.035 1.035 0 0 1 -0.36 -0.81q0 -0.189 0.026 -0.39 0.027 -0.197 0.087 -0.449l0.45 -1.59q0.06 -0.229 0.102 -0.432a1.95 1.95 0 0 0 0.039 -0.375q0 -0.304 -0.124 -0.423 -0.128 -0.12 -0.48 -0.12a1.2 1.2 0 0 0 -0.36 0.054 4.5 4.5 0 0 0 -0.312 0.105l0.12 -0.491q0.441 -0.18 0.844 -0.309 0.405 -0.129 0.764 -0.129 0.648 0 1.001 0.315 0.351 0.312 0.351 0.813 0 0.104 -0.024 0.364 -0.022 0.262 -0.09 0.48l-0.447 1.585a4.5 4.5 0 0 0 -0.099 0.435q-0.045 0.244 -0.044 0.37 0 0.315 0.141 0.43 0.143 0.115 0.491 0.115a2.1 2.1 0 0 0 0.669 -0.158l-0.12 0.488Zm-0.08 -6.435a1.05 1.05 0 0 1 -0.754 0.291 1.08 1.08 0 0 1 -0.758 -0.291 0.93 0.93 0 0 1 -0.315 -0.705q0 -0.414 0.315 -0.71a1.08 1.08 0 0 1 0.758 -0.294q0.441 0 0.754 0.294 0.315 0.295 0.315 0.708 0 0.414 -0.315 0.705Z" fill="#F5A623"/></svg>
                        <p v-if="state.bankDetails.expiryTime === null">
                            {{ $t("banktransfer.account.validity") }} <strong>{{ getExpiryTime(10) }}</strong> {{ $t("banktransfer.account.validity.rest") }}
                        </p>
                        <p v-else>
                            {{ $t("banktransfer.account.validity") }} <strong>{{ getCustomExpiryTime(state.bankDetails.expiryTime) }}</strong> {{ $t("banktransfer.account.validity.rest") }}
                        </p>
                    </div>
                </div>
                <PrimaryButton
                    :disabled="clickedButton"
                    :content="$t('banktransfer.pay.btn')"
                    @click="step2()"
                />
            <!-- </template> -->
            </div>

            <div v-else>
                <!-- render error here -->
                <h3 class="payment__status-header">{{ $t("banktransfer.transaction.status")}}</h3>
                <div class="account-box payment__status-info">
                    <p>
                        {{ $t("banktransfer.status.info")}}
                    </p>
                </div>
            </div>
        </template>
        <template
            v-if="
                state.currentView == 'BANK_TRANSFER_DETAILS_VIEW' &&
                    state.processing != true &&
                    clickedButton
            "
        >
            <div v-if="!checkError">
                <div v-if="showPrimaryInfo && !showSecondaryInfo">
                    <h3 class="payment__status-header">{{ $t("banktransfer.transaction.status")}}</h3>
                    <div class="account-box payment__status-info">
                        <p>
                            {{ $t("banktransfer.status.primary")}}
                        </p>
                        <div class="center">
                            <button
                                @click="(showSecondaryInfo = true), (showPrimaryInfo = false)"
                                type="button"
                            >
                                {{ $t("banktransfer.transaction.btn")}}
                            </button>
                        </div>
                    </div>
                </div>

                <div v-if="!showPrimaryInfo && showSecondaryInfo">
                    <h3 class="payment__status-header">{{ $t("banktransfer.transaction.status")}}</h3>
                    <div class="account-box payment__status-info">
                        <p>
                            {{ $t("banktransfer.status.secondary")}}
                        </p>
                        <div class="center">
                            <button @click="showSecondaryInfo = false" type="button">
                                {{ $t("banktransfer.status.btn")}}
                            </button>
                        </div>
                    </div>
                </div>

                <div v-if="!showSecondaryInfo && !showPrimaryInfo">
                    <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                        {{ $t("banktransfer.transaction.timer")}} {{ timer }}. <br/> <b>{{$t("banktransfer.transaction.refresh")}}.</b>
                    </p>
                    <div class="center">
                        <div class="loader-icon"></div>
                    </div>
                    <div class="payment__status">
                        <transfer-status title="Payment made" name="made"> </transfer-status>
                        <transfer-status
                            class="payment__status-confirmed"
                            title="Payment confirmed"
                            name="confirmed"
                        >
                        </transfer-status>
                        <div class="payment__status-help center">
                            <button
                                @click="showPrimaryInfo = true"
                                type="button"
                                class="help-button"
                            >
                                {{ $t("banktransfer.transaction.help")}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <!-- render error here -->
                <h3 class="payment__status-header">
                    {{ $t("banktransfer.transaction.status")}}
                </h3>
                <div class="account-box payment__status-info">
                    <p>
                        {{ $t("banktransfer.status.info")}}
                    </p>
                </div>
            </div>
        </template>
        <!-- <template
            v-if="
                state.currentView == 'BANK_TRANSFER_DETAILS_VIEW' &&
                    state.processing != true &&
                    clickedButton &&
                    showPrimaryInfo
            "
        >
            <h3 class="payment__status-header">Transaction status</h3>
            <div class="account-box payment__status-info">
                <p>
                    Normally, transfers are confirmed almost immediately, but, for slow
                    payments, it could take up to 30 minutes.
                </p>
                <div class="center">
                    <button
                        @click="(showSecondaryInfo = true), (showPrimaryInfo = false)"
                        type="button"
                    >
                        Next
                    </button>
                </div>
            </div>
        </template> -->
        <!-- <template
            v-if="
                state.currentView == 'BANK_TRANSFER_DETAILS_VIEW' &&
                    state.processing != true &&
                    clickedButton &&
                    showSecondaryInfo
            "
        >
            <h3 class="payment__status-header">Transaction status</h3>
            <div class="account-box payment__status-info">
                <p>
                    We’ll keep checking and once the transaction goes through, you will
                    get a receipt or a refund if it fails.
                </p>
                <div class="center">
                    <button @click="showSecondaryInfo = false" type="button">
                        Continue waiting
                    </button>
                </div>
            </div>
        </template> -->
        <template
            v-else-if="
                state.currentView == 'BANK_TRANSFER_INIT_VIEW' &&
                    state.processing != true
            "
        >
            <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                {{ $t("banktransfer.init.instruction")}}
            </p>
            <PrimaryButton
                :content="
                    [ $t('banktransfer.redirect.btn'), state.currency, state.amount.toLocaleString()]
                        .filter(Boolean)
                        .join(' ')
                "
                @click="step2(false)"
            />
        </template>
    </div>
</template>

<script>
import { toClipboard } from "@soerenmartius/vue3-clipboard";
import { ref, computed, onBeforeUnmount, watch, onUpdated } from "vue";
import { injectStore, mapState } from "redux-vuex";
import { getValueFromPath, autoInitialize, anHourFromNow, customExpiryTime } from "@/support/helpers";
// import loading from "@/assets/lottie/loading";
import CopyButton from "@/components/copy-button.vue";
import TransferStatus from "@/components/transfer-status.vue";
import PrimaryButton from "@/components/form/base-button";

export default {
    name: "BankTransfer",
    components: { CopyButton, PrimaryButton, TransferStatus },
    setup() {
        const store = injectStore();
        const checkoutData = ref(store.getState());
        const transactionSuccessful = ref(false);
        const check = ref(null);
        const showCopied = ref(false);
        const showPrimaryInfo = ref(false);
        const showSecondaryInfo = ref(false);
        const checkError = ref(false);
        let hasTriggeredAutoTransition = ref(false);
        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });
        const clickedButton = ref(false);

        const timer = computed(() => {
            let time = "";
            if (checkoutData.value.view.context.timerCurrent) {
                let duration = checkoutData.value.view.context.timerCurrent.time;
                let minutes = Math.floor(duration / 60);
                let seconds = duration % 60;
                // time = `Account number expires in ${minutes}mins ${seconds}secs`;
                if (minutes > 0 && minutes != 1) {
                    time = `${minutes}mins ${seconds}secs`;
                }
                else if (minutes == 1) {
                    time = `${minutes}min ${seconds}secs`;
                } 
                else {
                    time = `${seconds}secs`;
                }
            }
            else if(checkoutData.value.view.context.timerDuration) {
                let duration = checkoutData.value.view.context.timerDuration.time;
                let minutes = Math.floor(duration / 60);
                // let seconds = duration % 60;
                // time = `Account number expires in ${minutes}mins `;
                time = `${minutes}mins `;
            }
            return time;
        });
        function Next() {
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }
        function step2(clickedBtnOption = true) {
            checkError.value = false;
            Next();
            clickedBtnOption === true ? hasTriggeredAutoTransition.value = true : void 0;
            clickedButton.value = clickedBtnOption;
        }

        function getExpiryTime(offset) {
            return anHourFromNow(offset);
        }
        
        function getCustomExpiryTime(expiry) {
            return customExpiryTime(expiry);
        }

        const autoInitializePayment = autoInitialize("BANK_TRANSFER_INIT_VIEW");

        onUpdated(() =>  autoInitializePayment(checkoutData, Next));

        watch(checkoutData, (val) => {
            if ( val.view != undefined &&
                val.view.current != "BANK_TRANSFER_DETAILS_VIEW" &&
        checkoutData.value.processing != true
            ) {
                clickedButton.value = false;
            }
        });
        
        watch(() => checkoutData.value.info, (val) => {
            if  (val && 
                val.canSwitchDetailsView === true && 
                checkoutData.value.view !== undefined && 
                checkoutData.value.view.current === "BANK_TRANSFER_DETAILS_VIEW"
            ) {
                if (hasTriggeredAutoTransition.value === false) {
                    step2();
                }
            }
        });

        watch( () => checkoutData.value.error, (newData) => {
            const shouldReloadViewErrorCases = ["underpaid and refunded", "Transaction failed", "Sorry, transaction not found", "No message", "abandoned"];

            if (newData && !shouldReloadViewErrorCases.includes(newData)) {
                checkError.value = true;
            }
        });

        function copyToClipboard(data) {
            toClipboard(data);
            showCopied.value = true;
            setTimeout(() => {
                showCopied.value = false;
            }, 700);
        }

        onBeforeUnmount(() => {
            subscription();
        });

        return {
            state: mapState({
                currency: (state) =>
                    getValueFromPath(state, "currency.current") || null,
                amount: (state) => getValueFromPath(state, "amount") || null,
                inputs: (state) => getValueFromPath(state, "view.context.inputs") || {},
                processing: (state) => getValueFromPath(state, "processing") || false,
                actions: (state) =>
                    getValueFromPath(state, "view.context.$actions") || {},
                bankDetails: (state) =>
                    getValueFromPath(state, "view.context.details") || {},
                instructions: (state) =>
                    getValueFromPath(state, "view.context.instruction") || null,
                currentView: (state) => getValueFromPath(state, "view.current") || null,
            }),
            transactionSuccessful,
            getExpiryTime,
            getCustomExpiryTime,
            step2,
            check,
            copyToClipboard,
            timer,
            clickedButton,
            showCopied,
            showSecondaryInfo,
            showPrimaryInfo,
            checkError,
            Next,
        };
    },
};
</script>

<style lang="scss" scoped>
.timer {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 1.4rem;
  font-weight: 300;
  letter-spacing: 0.3px;
  color: #8d8d8d;
  margin-bottom: 0;
  padding-top: 2.6rem;
  font-size: 1.2rem;
  border-top: 1px solid #ececec;
}

.amount-info-excess {
    border-bottom: 1px solid #ECECEC;
    display: flex;
    /* align-items: center; */
    gap: 10px;
    padding-left: 1.5rem;
    padding-right: 2.8rem;
    padding-bottom: 2rem;
    margin-bottom: 1.5rem;
}
.amount-info-excess svg {
    flex: 0 0 5%;
    margin-top: 2px;
}
.amount-info-excess p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    color: #666666;
}

.dynamic-account-warning {
    border-top: 1px solid #ECECEC;

    display: flex;
    gap: 10px;
    padding-left: 1.5rem;
    padding-right: 2.8rem;
    padding-top: 1.5rem;
}
.dynamic-account-warning svg {
    flex: 0 0 5%;
    margin-top: 2px;
}
.dynamic-account-warning p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    color: #666666;
}

.copy-message {
  margin-left: 7px;
  font-size: 14px;
  line-height: 13px;
  color: #a6a6a6;
  animation: fade 0.2s ease;
}
@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.payment__instruction--ghs {
    display: flex;
    align-items: flex-start;
    position: relative;
    margin-top: 8px;
    gap: 5px;
    svg {
        margin-top: 4px;
    }

    p {
        font-style: italic;
        color: #828282;
        font-size: 16px;
        line-height: 19px;
        .more {
            color: #576AE6;
        }
    }

    &--steps {
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.3s ease, visibility 0.3s ease;

        position: absolute;
        background-color: #4F4F4F;
        right: -72%;
        top: -2rem;
        padding: 2.4rem;
        border-radius: 4px;
        z-index: 99;
        max-width: 260px;

        @media screen and (max-width: $breakpoint-middle * 1px) {
            margin-right: 2rem;
            right: 3rem;
            top: 5rem;
        }

        h5 {
            font-weight: 700;
            line-height: 18px;
            margin-bottom: 8px;
            font-size: 14px;
            color: #fff;
        }
        ol {
            padding-top: 12px;
            border-top: 1px dashed #7C7C7C;
            li {
                list-style-type: auto;
                color: #E0E0E0;
                font-size: 12px;
                line-height: 18px;
                margin-left: 12px;
            }
        }
    }
}

.payment__instruction--ghs:hover .payment__instruction--ghs--steps {
  opacity: 1;
  visibility: visible;
}
.payment__instruction--ghs--steps::before {
  content: "";
  position: absolute;
  border: 6px solid transparent;
  border-left-color: #4F4F4F;
  left: -6px;
  transform: translateX(-50%) rotate(180deg);

  @media screen and (max-width: $breakpoint-middle * 1px) {
    left: unset;
    top: -12px;
    right: 80%;
    transform: translateX(-50%) rotate(270deg);
  }
}
</style>